export default {
    namespace: 'DigitalTalent',
    translations: {
        zh: {
            hero: {
                kicker: 'Digital Talent Service',
                title: '数字化人才服务',
            },
            introLabel: 'INTRO',
            intro: {
                title: '简介',
                paragraphs: [
                    '我们是科技人才的全球发展伙伴，我们为你全程护航，将您的技术实力，精准转化为跨越国界的职业成就与人生增长，真正实现“让科技人才找到理想工作”的愿景'
                ]
            },
            core: {
                label: 'SERVICE',
                title: '服务',
                frameworkTitle: '一站式服务',
                frameworkDesc: '',
                frameworkLabels: {
                    platform: '一站式服务平台',
                    systems: '4个系统',
                    services: 'N个服务'
                },
                platform: {
                    title: '一站式服务平台',
                    subtitle: '',
                    paragraphs: [
                        '一站式服务平台是连接人才、企业与服务节点的统一入口，围绕评估、签证、培训与就业指导等关键环节进行协同管理，减少信息分散与重复沟通。',
                        '通过标准化流程与顾问陪伴，我们将服务进度清晰呈现、关键节点有序衔接，让跨境求职与落地过程更高效、更可控。'
                    ]
                },
                systems: {
                    title: '“4”个系统',
                    subtitle: '',
                    moreHint: '服务体系远不止这 4 个系统，这里展示的是当前最具代表性的 4 个核心模块。',
                    items: [
                        {
                            title: '人才评估系统',
                            subtitle: '深度咨询 + 双向画像分析 + 定制方案',
                            steps: [
                                {
                                    title: '深度咨询',
                                    description: '与人才一对一沟通，评估其技术能力、职业经历、发展诉求及家庭考量'
                                },
                                {
                                    title: '双向画像分析',
                                    bullets: [
                                        '人才画像：运用AI工具与顾问经验，对简历进行深度解析与竞争力评估',
                                        '机会画像：基于公司独有的“人才数据库”，初步筛选匹配的派遣职位、国内高潜项目或潜在的创业合作伙伴（BP）'
                                    ]
                                },
                                {
                                    title: '定制方案',
                                    description: '结合对中日两国产业政策的深入了解，为人才规划1-3年的发展路径，明确主要方，如技术派遣'
                                }
                            ]
                        },
                        {
                            title: '签证办理系统',
                            subtitle: '定向方案 + 材料准备 + 行前培训 + 跨境安家',
                            steps: [
                                {
                                    title: '定向方案',
                                    description: '根据海外公司的性质、职位及派遣时长，确定最优签证类型（如技术·人文知识·国际业务、企业内转勤等），并列出完整的申请材料清单'
                                },
                                {
                                    title: '材料准备',
                                    description: '指导并协助候选人及贵司准备全套申请材料，由日本办事处专员进行合规性审核后，向入管局递交申请，并全程跟踪进度'
                                },
                                {
                                    title: '行前培训',
                                    description: '在签证获批后，为候选人提供必要的日本劳动法规、税务及社会保险说明，并协助完善雇佣合同或派遣协议，确保法律环节无遗漏'
                                },
                                {
                                    title: '跨境安家',
                                    description: '我们专业的在地团队为您承接，从签证手续、住宿安排到银行开户、社保办理，提供标准化的一站式解决方案'
                                }
                            ]
                        },
                        {
                            title: '技能培训系统',
                            subtitle: '岗位技能缺口分析 + 定制化培训 + 培训效果验证',
                            steps: [
                                {
                                    title: '岗位技能缺口分析',
                                    description: '我们对接海外团队管理者，精准识别人才能力差距，交付定制化能力转型方案，确保培训完全匹配岗位需求'
                                },
                                {
                                    title: '定制化培训',
                                    bullets: [
                                        '1. 技术实战工作坊：聚焦当地主流技术栈、开发流程与行业解决方案，通过代码审查、案例重构等形式进行强化。',
                                        '2. 商业语境沉浸：超越日常用语，专攻商务会议、技术研讨、客户沟通及邮件文书等场景下的精准表达与逻辑构建。'
                                    ]
                                },
                                {
                                    title: '培训效果验证',
                                    bullets: [
                                        '1. 多维能力评估报告：我们将提供包含技术产出、沟通效率的综合评估报告，清晰展示培训前后对比',
                                        '2. 启动长期学习账户：培训结束后，人才将获得专属学习账户，持续访问更新的行业资料、技术文档与文化播客，实现能力的自我迭代'
                                    ]
                                }
                            ]
                        },
                        {
                            title: '就业指导系统',
                            subtitle: '签约指导 + 跨文化融入 + 生态连接',
                            steps: [
                                {
                                    title: '签约指导',
                                    description: '确保人才获得公平、合规且有竞争力的雇佣条件，奠定长期稳定的合作基础。'
                                },
                                {
                                    title: '跨文化融入',
                                    description: '缩短海外岗位适应期，助力人才快速从“新人”转化为“有效贡献者”。'
                                },
                                {
                                    title: '生态连接',
                                    description: '鼓励成功人才成为生态推荐者或导师，其数据在脱敏后丰富公司人才库，形成“人才吸引-成功服务-生态反哺”的正向循环。'
                                }
                            ]
                        }
                    ]
                },
                supportPackage: {
                    title: '“N”个服务',
                    subtitle: '',
                    moreHint: '服务体系远不止这 4 个系统，这里展示的是当前最具代表性的 4 个核心模块。',
                    items: [
                        {
                            title: '面试模拟',
                            description: '还原真实面试场景与专业挑战'
                        },
                        {
                            title: '职业规划指导',
                            description: '绘制清晰的进阶路径'
                        },
                        {
                            title: '签证手续办理',
                            description: '告别繁琐流程与潜在风险'
                        },
                        {
                            title: '项目实战',
                            description: '在真实的商业场景中锻造您的经验“含金量”'
                        }
                    ]
                }
            },
            process: {
                label: 'PROCESS',
                title: '流程',
                sections: [
                    {
                        title: '人才招聘',
                        description: '我们重新定义科技求职，不只是简单匹配岗位信息，更帮你挖掘个人价值、实现精准深度对接。依托 AI + 专业顾问双重支持，为你打造从挖掘潜在机会到长期职业发展的智能求职助力',
                        bullets: [
                            'AI 智能匹配岗位：用 Dify 等 AI 工具分析海量职位和你的简历，快速精准匹配合适工作，不用盲目投递，求职更高效。',
                            '全程求职辅导：从优化简历、模拟面试到薪酬谈判，全程专业指导，还有 AI 面试官演练、资深顾问支招，帮你从容应对求职各环节。',
                            '长期职业陪伴：不只帮你成功入职，还会建立人才档案、持续分析职业竞争力，入职后也提供支持，助力你职业长期成长增值'
                        ]
                    },
                    {
                        title: '人才培训',
                        description: '为变化世界储备核心竞争力，我们聚焦数字科技前沿缺口与实战需求，提供技术 + 软实力系统化培训，将知识转化为实战能力，助你胜任当下、引领未来',
                        flowLabel: '培训流程',
                        flows: [
                            '签证手续办理：告别繁琐流程与潜在风险',
                            '面试模拟：还原真实面试场景与专业挑战',
                            '项目实战:在真实的商业场景中锻造您的经验“含金量”',
                            '职业规划指导:绘制清晰的进阶路径'
                        ]
                    },
                    {
                        title: '人才派遣',
                        description: '我们提供一种敏捷、低风险且富含多样性的职业发展路径。通过我们的派遣服务，您将以专家身份快速嵌入顶尖科技企业的核心项目中，在真实的商业场景中锤炼技能、积累高阶项目经验并拓展行业人脉',
                        bullets: [
                            '项目快速嵌入：对接企业核心项目与真实业务需求，缩短从进入岗位到形成产出的适应周期。',
                            '经验阶梯积累：在多元项目环境中持续沉淀技术深度、协作经验与跨团队交付能力。',
                            '职业路径延展：在拓展行业人脉与国际化视野的同时，为后续长期任职、岗位升级或方向转型打开更大空间。'
                        ]
                    }
                ]
            },
            career: {
                label: 'CAREER',
                title: '准备开启出海发展？',
                description: '如果你希望进一步了解岗位机会、投递方式与加入流程，可以直接进入“加入未来世界”页面查看完整招聘信息。',
                cta: '查看加入未来世界 →'
            }
        },
        en: {
            hero: {
                kicker: 'Digital Talent Service',
                title: 'Digital Talent Service',
            },
            introLabel: 'INTRO',
            intro: {
                title: 'Introduction',
                paragraphs: [
                    'We are the global development partner for technology talent. We support you throughout the entire journey, accurately transforming your technical strength into cross-border career achievement and life growth, truly realizing the vision of helping technology talent find ideal jobs.'
                ]
            },
            core: {
                label: 'SERVICE',
                title: 'Services',
                frameworkTitle: 'One-stop Service',
                frameworkDesc: '',
                frameworkLabels: {
                    platform: 'One-stop Service Platform',
                    systems: '4 Systems',
                    services: 'N Services'
                },
                platform: {
                    title: 'One-stop Service Platform',
                    subtitle: '',
                    paragraphs: [
                        'The one-stop service platform serves as a unified entry point connecting talent, enterprises, and service nodes, coordinating key stages such as assessment, visa processing, training, and employment guidance while reducing fragmented information and repeated communication.',
                        'Through standardized workflows and consultant support, we make progress transparent and each key step smoothly connected, making cross-border job seeking and onboarding more efficient and more controllable.'
                    ]
                },
                systems: {
                    title: 'The 4 Systems',
                    subtitle: '',
                    moreHint: 'These services go well beyond only four systems. Here we are showing four representative core modules.',
                    items: [
                        {
                            title: 'Talent Assessment System',
                            subtitle: 'In-depth Consultation + Two-way Profile Analysis + Customized Plan',
                            steps: [
                                {
                                    title: 'In-depth Consultation',
                                    description: 'Communicate one-on-one with talent to assess technical capability, career experience, development goals, and family considerations.'
                                },
                                {
                                    title: 'Two-way Profile Analysis',
                                    bullets: [
                                        'Talent profile: Use AI tools and consultant experience to deeply analyze resumes and evaluate competitiveness.',
                                        'Opportunity profile: Based on the company\'s unique talent database, conduct initial screening for matching dispatch positions, high-potential domestic projects, or potential entrepreneurial partners (BP).'
                                    ]
                                },
                                {
                                    title: 'Customized Plan',
                                    description: 'Based on an in-depth understanding of cross-border industry policies and market dynamics, plan a 1-3 year development path for talent and clarify the main direction, such as technical dispatch.'
                                }
                            ]
                        },
                        {
                            title: 'Visa Processing System',
                            subtitle: 'Targeted Plan + Material Preparation + Pre-departure Training + Cross-border Settlement',
                            steps: [
                                {
                                    title: 'Targeted Plan',
                                    description: 'According to the nature of the overseas company, position, and dispatch duration, determine the optimal visa type, such as Engineer / Specialist in Humanities / International Services or Intra-company Transferee, and provide a complete checklist of application materials.'
                                },
                                {
                                    title: 'Material Preparation',
                                    description: 'Guide and assist candidates and your company in preparing the full set of application materials. After compliance review by specialists in the Japan office, we submit the application to immigration and track progress throughout the process.'
                                },
                                {
                                    title: 'Pre-departure Training',
                                    description: 'After visa approval, provide candidates with necessary explanations of Japanese labor regulations, taxation, and social insurance, and assist in refining employment contracts or dispatch agreements to ensure no legal steps are missed.'
                                },
                                {
                                    title: 'Cross-border Settlement',
                                    description: 'Our professional local team supports you with visa procedures, accommodation arrangements, bank account opening, and social insurance processing, providing a standardized one-stop solution.'
                                }
                            ]
                        },
                        {
                            title: 'Skills Training System',
                            subtitle: 'Skill Gap Analysis + Customized Training + Training Effect Verification',
                            steps: [
                                {
                                    title: 'Job Skill Gap Analysis',
                                    description: 'We connect with overseas team managers, accurately identify talent capability gaps, and deliver customized capability transformation plans to ensure the training fully matches job requirements.'
                                },
                                {
                                    title: 'Customized Training',
                                    bullets: [
                                        '1. Technical workshop: Focus on mainstream local technology stacks, development processes, and industry solutions, strengthened through code reviews and case refactoring.',
                                        '2. Business context immersion: Go beyond daily language and focus on precise expression and logical structuring in business meetings, technical discussions, client communication, and email writing.'
                                    ]
                                },
                                {
                                    title: 'Training Effect Verification',
                                    bullets: [
                                        '1. Multi-dimensional capability assessment report: We provide a comprehensive report covering technical output and communication efficiency, clearly showing before-and-after comparisons.',
                                        '2. Launch a long-term learning account: After training, talent receives an exclusive learning account with continuous access to updated industry materials, technical documents, and cultural podcasts for ongoing self-iteration.'
                                    ]
                                }
                            ]
                        },
                        {
                            title: 'Employment Guidance System',
                            subtitle: 'Contract Guidance + Cross-cultural Integration + Ecosystem Connection',
                            steps: [
                                {
                                    title: 'Contract Guidance',
                                    description: 'Ensure talent receives fair, compliant, and competitive employment conditions, laying the foundation for long-term stable cooperation.'
                                },
                                {
                                    title: 'Cross-cultural Integration',
                                    description: 'Shorten the adaptation period for overseas roles and help talent quickly transform from newcomers into effective contributors.'
                                },
                                {
                                    title: 'Ecosystem Connection',
                                    description: 'Encourage successful talent to become recommenders or mentors. After anonymization, their data enriches the company talent pool and forms a positive cycle of talent attraction, successful service, and ecosystem feedback.'
                                }
                            ]
                        }
                    ]
                },
                supportPackage: {
                    title: 'N Services',
                    subtitle: '',
                    moreHint: 'The service system goes far beyond these four systems. Here we are showing only four representative core modules.',
                    items: [
                        {
                            title: 'Interview Simulation',
                            description: 'Recreate real interview scenarios and professional challenges'
                        },
                        {
                            title: 'Career Planning Guidance',
                            description: 'Map out a clear advancement path'
                        },
                        {
                            title: 'Visa Procedure Handling',
                            description: 'Say goodbye to tedious processes and potential risks'
                        },
                        {
                            title: 'Project Practice',
                            description: 'Forge the value of your experience in real business scenarios'
                        }
                    ]
                }
            },
            process: {
                label: 'PROCESS',
                title: 'Process',
                sections: [
                    {
                        title: 'Talent Recruitment',
                        description: 'We redefine tech job seeking. It is not just simple job matching, but also helping you uncover personal value and achieve precise, in-depth connection. With dual support from AI and professional consultants, we build intelligent job-search support for you, from discovering hidden opportunities to long-term career development.',
                        bullets: [
                            'AI-powered job matching: Use AI tools such as Dify to analyze large volumes of positions and your resume, quickly and accurately matching suitable jobs so you can avoid blind applications and make job seeking more efficient.',
                            'Full-process job guidance: From resume optimization and mock interviews to salary negotiation, we provide professional guidance throughout, including AI interviewer practice and advice from senior consultants.',
                            'Long-term career support: We do more than help you get hired. We also build talent profiles, continuously analyze career competitiveness, and provide support after onboarding to promote long-term career growth.'
                        ]
                    },
                    {
                        title: 'Talent Training',
                        description: 'To build core competitiveness for a changing world, we focus on frontier gaps and practical needs in digital technology, providing systematic training in both technical and soft skills, turning knowledge into practical capability so you can handle today and lead the future.',
                        flowLabel: 'Training Process',
                        flows: [
                            'Visa procedure handling: Say goodbye to tedious processes and potential risks',
                            'Interview simulation: Recreate real interview scenarios and professional challenges',
                            'Project practice: Forge the value of your experience in real business scenarios',
                            'Career planning guidance: Map out a clear advancement path'
                        ]
                    },
                    {
                        title: 'Talent Dispatch',
                        description: 'We provide an agile, low-risk, and diverse career development path. Through our dispatch service, you will quickly embed yourself as a specialist into the core projects of top technology companies, sharpen your skills in real business scenarios, accumulate high-level project experience, and expand your industry network.',
                        bullets: [
                            'Fast project integration: Connect with core enterprise projects and real business needs, shortening the time from onboarding to meaningful output.',
                            'Layered experience building: Continue to accumulate technical depth, collaboration experience, and cross-team delivery capability in diverse project environments.',
                            'Expanded career pathways: While broadening industry connections and global perspective, create more room for long-term placement, role advancement, or future transition.'
                        ]
                    }
                ]
            },
            career: {
                label: 'CAREER',
                title: 'Ready to Start Your Overseas Career?',
                description: 'If you want to explore role opportunities, application details, and the overall joining process, you can head to the Join Future World page for the full recruitment information.',
                cta: 'View Join Future World →'
            }
        },
        ja: {
            hero: {
                kicker: 'Digital Talent Service',
                title: 'デジタル人材サービス',
            },
            introLabel: 'INTRO',
            intro: {
                title: '概要',
                paragraphs: [
                    '私たちはテクノロジー人材のグローバル成長パートナーです。全過程で伴走し、あなたの技術力を国境を越えたキャリアの成果と人生の成長へと的確に変換し、「テクノロジー人材に理想の仕事を見つけてもらう」というビジョンを真に実現します。'
                ]
            },
            core: {
                label: 'SERVICE',
                title: 'サービス',
                frameworkTitle: 'ワンストップサービス',
                frameworkDesc: '',
                frameworkLabels: {
                    platform: 'ワンストップサービスプラットフォーム',
                    systems: '4つのシステム',
                    services: 'Nのサービス'
                },
                platform: {
                    title: 'ワンストップサービスプラットフォーム',
                    subtitle: '',
                    paragraphs: [
                        'ワンストップサービスプラットフォームは、人材・企業・各種サービス工程をつなぐ統合入口として機能し、評価、ビザ、研修、就業支援などの主要プロセスを一体的に管理しながら、情報の分散や重複コミュニケーションを減らします。',
                        '標準化されたフローとコンサルタントの伴走により、進行状況を見えやすくし、重要な工程を滑らかにつなげることで、越境就職から定着までをより効率的かつ管理しやすいものにします。'
                    ]
                },
                systems: {
                    title: '4つのシステム',
                    subtitle: '',
                    moreHint: 'サービス体系はこの4つにとどまりません。ここでは代表的な4つの中核モジュールを例としてご紹介しています。',
                    items: [
                        {
                            title: '人材評価システム',
                            subtitle: '深度相談 + 双方向プロファイル分析 + カスタマイズプラン',
                            steps: [
                                {
                                    title: '深度相談',
                                    description: '人材と1対1で対話し、技術力、職務経歴、成長ニーズ、家庭面の考慮を評価します。'
                                },
                                {
                                    title: '双方向プロファイル分析',
                                    bullets: [
                                        '人材プロファイル：AIツールとコンサルタントの経験を活用し、履歴書を深く解析して競争力を評価します。',
                                        '機会プロファイル：会社独自の「人材データベース」に基づき、適合する派遣ポジション、国内の有望プロジェクト、または潜在的な起業パートナー（BP）を初期選定します。'
                                    ]
                                },
                                {
                                    title: 'カスタマイズプラン',
                                    description: '越境産業政策と市場動向への深い理解を踏まえ、人材の1〜3年の成長ルートを設計し、技術派遣などの主要方向を明確にします。'
                                }
                            ]
                        },
                        {
                            title: 'ビザ申請システム',
                            subtitle: '最適化プラン + 書類準備 + 渡航前研修 + 越境定住支援',
                            steps: [
                                {
                                    title: '最適化プラン',
                                    description: '海外企業の性質、職種、派遣期間に応じて、最適なビザ種別を決定し、必要書類の一覧を提示します。'
                                },
                                {
                                    title: '書類準備',
                                    description: '候補者および貴社の申請書類一式の準備を支援し、日本オフィスの担当者が適法性を確認したうえで入管局へ申請し、進捗を追跡します。'
                                },
                                {
                                    title: '渡航前研修',
                                    description: 'ビザ承認後、日本の労働法、税務、社会保険に関する必要な説明を行い、雇用契約または派遣契約の整備も支援して、法務面の漏れを防ぎます。'
                                },
                                {
                                    title: '越境定住支援',
                                    description: '現地チームがビザ手続き、住居手配、銀行口座開設、社会保険手続きを引き受け、標準化されたワンストップソリューションを提供します。'
                                }
                            ]
                        },
                        {
                            title: 'スキルトレーニングシステム',
                            subtitle: '職種スキルギャップ分析 + カスタマイズ研修 + 研修効果検証',
                            steps: [
                                {
                                    title: '職種スキルギャップ分析',
                                    description: '海外チームの管理者と連携し、人材の能力差を正確に把握したうえで、職務要件に完全対応した能力転換プランを提供します。'
                                },
                                {
                                    title: 'カスタマイズ研修',
                                    bullets: [
                                        '1. 技術実践ワークショップ：現地主流の技術スタック、開発プロセス、業界ソリューションに焦点を当て、コードレビューやケース再構成などで強化します。',
                                        '2. ビジネス文脈への没入：日常会話を超え、商談、技術討議、顧客対応、メール文書などの場面での正確な表現と論理構築に特化します。'
                                    ]
                                },
                                {
                                    title: '研修効果検証',
                                    bullets: [
                                        '1. 多面的能力評価レポート：技術アウトプットとコミュニケーション効率を含む総合評価レポートを提供し、研修前後の比較を明確に示します。',
                                        '2. 長期学習アカウントの開始：研修終了後、人材には専用学習アカウントが付与され、更新された業界資料、技術文書、文化ポッドキャストへ継続アクセスできます。'
                                    ]
                                }
                            ]
                        },
                        {
                            title: '就業ガイダンスシステム',
                            subtitle: '契約サポート + 異文化適応 + エコシステム接続',
                            steps: [
                                {
                                    title: '契約サポート',
                                    description: '人材が公平で適法かつ競争力のある雇用条件を得られるようにし、長期安定的な協業の基盤を築きます。'
                                },
                                {
                                    title: '異文化適応',
                                    description: '海外ポジションへの適応期間を短縮し、「新人」から「有効な貢献者」への転換を後押しします。'
                                },
                                {
                                    title: 'エコシステム接続',
                                    description: '成功した人材が推薦者やメンターになることを促し、匿名化後のデータで人材プールを豊かにし、「人材誘引-成功支援-エコ反哺」の好循環を形成します。'
                                }
                            ]
                        }
                    ]
                },
                supportPackage: {
                    title: 'Nのサービス',
                    subtitle: '',
                    moreHint: 'サービス体系はこの4つのシステムにとどまりません。ここでは代表的な4つの中核モジュールのみをご紹介しています。',
                    items: [
                        {
                            title: '面接シミュレーション',
                            description: '実際の面接場面と専門的な課題を再現'
                        },
                        {
                            title: 'キャリアプラン指導',
                            description: '明確な成長ルートを描く'
                        },
                        {
                            title: 'ビザ手続き代行',
                            description: '煩雑な手続きと潜在リスクに別れを告げる'
                        },
                        {
                            title: 'プロジェクト実践',
                            description: '実際のビジネスシーンで経験の価値を鍛える'
                        }
                    ]
                }
            },
            process: {
                label: 'PROCESS',
                title: 'プロセス',
                sections: [
                    {
                        title: '人材採用',
                        description: '私たちはテック人材の求職を再定義します。単なる求人情報のマッチングではなく、個人の価値を掘り起こし、より精密で深い接続を実現します。AIとプロフェッショナルコンサルタントの二重支援により、潜在機会の発掘から長期的なキャリア成長まで、スマートな求職支援を提供します。',
                        bullets: [
                            'AIによる求人マッチング：DifyなどのAIツールで大量の求人情報と履歴書を分析し、適切な仕事を迅速かつ正確にマッチングすることで、やみくもな応募を避け、求職効率を高めます。',
                            '全過程の求職支援：履歴書の最適化、模擬面接、報酬交渉まで、AI面接官の演習やシニアコンサルタントの助言を含む専門支援を提供します。',
                            '長期キャリア伴走：入社成功の支援にとどまらず、人材プロフィールの構築、競争力の継続分析、入社後支援を通じて長期的な成長を後押しします。'
                        ]
                    },
                    {
                        title: '人材研修',
                        description: '変化する世界に向けた中核競争力を蓄えるため、私たちはデジタルテクノロジー最前線のギャップと実践ニーズに焦点を当て、技術力とソフトスキルの両面から体系的な研修を提供し、知識を実践力へと転換します。',
                        flowLabel: '研修フロー',
                        flows: [
                            'ビザ手続き代行：煩雑な手続きと潜在リスクに別れを告げる',
                            '面接シミュレーション：実際の面接場面と専門的な課題を再現',
                            'プロジェクト実践：実際のビジネスシーンで経験の価値を鍛える',
                            'キャリアプラン指導：明確な成長ルートを描く'
                        ]
                    },
                    {
                        title: '人材派遣',
                        description: '私たちは、俊敏で低リスクかつ多様性に富んだキャリア発展ルートを提供します。派遣サービスを通じて、あなたは専門家としてトップクラスのテック企業の中核プロジェクトに素早く入り込み、実際のビジネスシーンでスキルを磨き、高度なプロジェクト経験を蓄積し、業界ネットワークを広げることができます。',
                        bullets: [
                            'プロジェクトへの迅速な参画：企業の中核案件と実際の業務ニーズにつながり、着任から成果創出までの立ち上がり期間を短縮します。',
                            '経験の段階的蓄積：多様なプロジェクト環境の中で、技術の深さ、協働経験、チーム横断のデリバリー力を継続的に蓄積します。',
                            'キャリアパスの拡張：業界ネットワークと国際的視野を広げながら、長期就業、職位アップ、将来の転向に向けた可能性を広げます。'
                        ]
                    }
                ]
            },
            career: {
                label: 'CAREER',
                title: '海外でのキャリアを始めませんか？',
                description: '募集職種、応募方法、参加プロセスの詳細を知りたい方は、「未来世界に参加する」ページから採用情報をご確認ください。',
                cta: '採用情報を見る →'
            }
        }
    }
};
